/*
  Ähnliche Produkte — vollbreites, swipebares Karussell mit Pfeilen.

  Quelle-Priorität:
    1) Native Metafelder (custom.related_products + custom.complementary_products)
       werden SERVER-SEITIG im Snippet snippet-strip-related-trautis.liquid gerendert.
       Deren Handles stehen in [data-related-strip][data-shown-handles].
    2) Reichen die kuratierten Produkte nicht bis [data-target], füllt dieses Modul
       per Fitment auf: pro Fahrzeug-GID via templates/collection.related-cards.liquid,
       dedupt gegen die schon gezeigten Handles + das aktuelle Produkt.

  Pfeile (prev/next) scrollen den Rail; werden nur gezeigt, wenn der Inhalt überläuft.
  Strip wird entfernt, wenn am Ende keine echte Karte übrig bleibt.

  Keine Event-Subscriptions auf Varianten: das Kandidaten-Set hängt am Produkt,
  nicht an der Variante.
*/

(function (root, factory) {
  var api = factory(typeof window !== 'undefined' ? window : null);
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  } else {
    root.TrautisSimilar = api;
    if (root.document && root.document.addEventListener) {
      if (root.document.readyState === 'loading') {
        root.document.addEventListener('DOMContentLoaded', api.init);
      } else {
        api.init();
      }
    }
  }
})(typeof window !== 'undefined' ? window : this, function (win) {
  'use strict';

  var DEFAULT_TARGET = 12;

  function parseHandleList(str) {
    return (str || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(function (s) { return s.length > 0; });
  }

  function fetchCardsForGid(gid) {
    var url = '/collections/all?filter.p.m.custom.fitment_applications=' +
      encodeURIComponent(gid) + '&view=related-cards';
    return fetch(url).then(function (r) { return r.text(); });
  }

  function removeSkeletons(rail) {
    var skels = rail.querySelectorAll ? rail.querySelectorAll('[data-strip-skeleton]') : [];
    for (var i = 0; i < skels.length; i++) {
      if (skels[i].remove) skels[i].remove();
    }
  }

  function realCardCount(rail) {
    return rail.querySelectorAll ? rail.querySelectorAll('[data-related-card]').length : 0;
  }

  function setupArrows(stripEl, rail) {
    var prev = stripEl.querySelector('[data-strip-prev]');
    var next = stripEl.querySelector('[data-strip-next]');
    if (!prev || !next || !rail.addEventListener) return;

    function update() {
      var maxScroll = rail.scrollWidth - rail.clientWidth;
      if (maxScroll <= 2) {
        // Content fits → no arrows at all.
        prev.hidden = true;
        next.hidden = true;
        return;
      }
      // Hide (don't dim) the arrow you can't use at each scroll boundary.
      prev.hidden = rail.scrollLeft <= 1;
      next.hidden = rail.scrollLeft >= maxScroll - 1;
    }

    function step(direction) {
      var amount = Math.max(rail.clientWidth * 0.8, 200);
      rail.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    rail.addEventListener('scroll', update, { passive: true });
    if (win && win.addEventListener) win.addEventListener('resize', update);
    update();
  }

  // Finish a strip: drop skeletons, remove if empty, otherwise reveal + wire arrows.
  function finalize(stripEl, rail) {
    removeSkeletons(rail);
    if (realCardCount(rail) === 0) {
      stripEl.remove();
      return;
    }
    if (stripEl.removeAttribute) stripEl.removeAttribute('aria-busy');
    setupArrows(stripEl, rail);
  }

  function process(stripEl) {
    var rail = stripEl.querySelector('[data-strip-rail]');
    if (!rail) return Promise.resolve();

    var target = parseInt(stripEl.dataset && stripEl.dataset.target, 10);
    if (!target || target < 1) target = DEFAULT_TARGET;

    var seen = {};
    var shown = parseHandleList(stripEl.dataset && stripEl.dataset.shownHandles);
    for (var s = 0; s < shown.length; s++) seen[shown[s]] = true;
    var currentHandle = (stripEl.dataset && stripEl.dataset.currentHandle) || '';
    if (currentHandle) seen[currentHandle] = true;

    var needed = target - shown.length;
    var gids = parseHandleList(stripEl.dataset && stripEl.dataset.fitmentGids);

    // Curated already satisfies the target, or no fitment source to fill from.
    if (needed <= 0 || gids.length === 0) {
      finalize(stripEl, rail);
      return Promise.resolve();
    }

    return Promise.all(gids.map(fetchCardsForGid)).then(function (htmls) {
      var toAppend = [];
      for (var i = 0; i < htmls.length; i++) {
        var doc = new DOMParser().parseFromString(htmls[i], 'text/html');
        var nodes = doc.querySelectorAll('[data-related-card]');
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          var h = node.dataset && node.dataset.productHandle;
          if (!h || seen[h]) continue;
          seen[h] = true;
          toAppend.push(node);
          if (toAppend.length >= needed) break;
        }
        if (toAppend.length >= needed) break;
      }
      for (var k = 0; k < toAppend.length; k++) {
        if (rail.appendChild) rail.appendChild(toAppend[k]);
      }
      finalize(stripEl, rail);
    }).catch(function (_) {
      // Fetch failed — keep any server-rendered curated cards, drop skeletons.
      finalize(stripEl, rail);
    });
  }

  function init() {
    var strips = document.querySelectorAll('[data-related-strip]');
    for (var i = 0; i < strips.length; i++) {
      process(strips[i]);
    }
  }

  return {
    init: init,
    process: process,
  };
});
